/**
 * The keyboard-focus ring, in one place. Every control that draws one draws the
 * same one: 2px, solid, offset clear of the control's own edge.
 *
 * `halo` is for a ring that has to survive a background of any colour - a white
 * ring with a dark shadow behind it reads on both a white and a black slide,
 * where a single colour reads on only one of them.
 */
export const focusRing = (color, { offset = '1px', halo = null } = {}) => ({
    outline: `2px solid ${color}`,
    outlineOffset: offset,
    ...(halo ? { boxShadow: halo } : {})
});
